import { useCallback, useRef } from 'react';
import { openMultiCampaignReset, openSingleCampaignReset } from './resetCampaignHelpers';

/**
 * Opens the reset-campaign modal, loads docs/tree impact, and runs confirm/undo.
 */
const useResetCampaignProgress = ({
  localSprint,
  setLocalSprint,
  statuses,
  allSprints,
  isMultiCampaignMode,
  loadFullSprint,
  onUpdateSprint,
  modals,
  recordAction,
}) => {
  const resetDocsByIdRef = useRef(null);
  /** Nested sprints resolved while preparing the modal (avoids stale allSprints). */
  const resetTreeSprintsRef = useRef(null);

  return useCallback(() => {
    if (isMultiCampaignMode) {
      openMultiCampaignReset({
        localSprint,
        setLocalSprint,
        allSprints,
        modals,
        recordAction,
        resetDocsByIdRef,
      });
      return;
    }

    openSingleCampaignReset({
      localSprint,
      setLocalSprint,
      statuses,
      allSprints,
      loadFullSprint,
      onUpdateSprint,
      modals,
      recordAction,
      resetDocsByIdRef,
      resetTreeSprintsRef,
    });
  }, [
    allSprints,
    isMultiCampaignMode,
    loadFullSprint,
    localSprint,
    modals,
    onUpdateSprint,
    recordAction,
    setLocalSprint,
    statuses,
  ]);
};

export default useResetCampaignProgress;
